// src/App.js
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import "./styles.css";
import ChatBubble from "./ChatBubble";
import ChatInput from "./ChatInput";
import { floatAssistantSystemPrompt } from './floatSystemPrompt.js';

function buildAppointmentLink({ sessionTypeId, staffId, startTime }) {
  const base = "https://cart.mindbodyonline.com/sites/12331/cart/add_booking";
  const params = new URLSearchParams({
    "item[mbo_location_id]": "1",                 // Always 1
    "item[staff_requested]": "false",             // Always false
    "item[session_type_id]": sessionTypeId,       // Passed in
    "item[staff_id]": staffId,                    // Passed in
    "item[start_date_time]": startTime,           // ISO format (e.g. 2025-09-24T20:00:00)
    "item[type]": "Appointment"                   // Always Appointment
  });

  return `${base}?${params.toString()}`;
}

function popupsAllowed() {
  try {
    const test = window.open('', '_blank', 'width=100,height=100');

    // If null → definitely blocked
    if (!test) return false;

    // If it opened but closed immediately → also blocked
    if (test.closed) return false;

    // Clean up
    test.close();
    return true;
  } catch {
    return false;
  }
}


const App = () => {
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Hi there! I'm The FLOAT Guide. How can I help you today? Would you like to hear about our services?" }
  ]);

  const [serviceData, setServiceData] = useState([]);
  const [appointments,setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [appointmentID,setAppointmentID] = useState(-1);
  const [queryDate, setDate] = useState(new Date(Date.now()));
  const [wantsData, setWants] = useState(true);
  const appointmentRef = useRef(appointmentID);
  const queryRef = useRef(queryDate);
  const messageRef = useRef(messages);

   useEffect(() => {
    queryRef.current = queryDate; // keep ref in sync with state
    appointmentRef.current = appointmentID;
    messageRef.current = messages;
   }, [queryDate,appointmentID,messages]);

// Call this from a user-initiated click to avoid popup blockers
const redirectToBooking = (url) => {
  const newWindow = window.open(url, "_blank");

  if (!newWindow) {
    // Fallback in case popup was blocked — redirect current tab
    window.location.href = url;
  }
};

  const ip = "floatgpt.duckdns.org";

  const todaysDate = queryDate.toISOString().split("T")[0];

  const setDefaultPrompt = async (wantsContext) => {
      //console.log("Entered Default Prompt with wantsContext: " + wantsContext);

      var prompt = floatAssistantSystemPrompt;
      if(wantsContext) { //empty
        if(serviceData.length === 0) {
          const {data} = await axios.get("https://"+ip+"/api/appointments-prepared");
          var appointmentArray = data;
          //console.log(appointmentArray);
          setServiceData(appointmentArray);
          prompt = prompt + "\n currentService information: " + JSON.stringify(appointmentArray);

       } else prompt = prompt + "\n currentService information: " + JSON.stringify(serviceData);
       
        if (appointments.length !== 0) {
        	 prompt = prompt + "\n currentAppointment information: " + JSON.stringify(appointments);
        }
      } 

      prompt = prompt + "\nHere is the context of previous messages between yourself and the user. You are 'bot' and the customer is 'user': " + JSON.stringify(messageRef.current);

     return prompt;
  }
  const manageserviceData = async (appointmentInfo,startDate, newMessages, timeOfDay = []) => {
      //console.log("Entered");
//      var message = "Show me the available scheduled times you were provided with! If none tell me you don't have any!";
       //console.log("APPOINTMENTINFO: ", appointmentInfo, startDate.toISOString());
       var allowed = ["Morning","Afternoon","Evening","Night"];
       if (timeOfDay.length !== 0)
       {
        allowed = timeOfDay;
       }

      if (appointmentInfo >= 0)
      {
      startDate.setDate(startDate.getDate() + 1); 
      startDate.setHours(0,0,0,0)
      const endDate = new Date(startDate); // clone
//      endDate.setDate(startDate.getDate() + 1);
      endDate.setHours(23, 59, 0, 0);
      //console.log(startDate.getDate() + "-" +endDate.getDate())
       //they want to schedule       
       const scheduleWanted = await axios.post("https://"+ip+"/api/getschedule", {
//       const scheduleWanted = await axios.post("http://localhost:5001/api/getschedule", {
          appointmentTypeId: appointmentInfo,
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString()
        });

         //console.log("AVAILABLITIES: ", scheduleWanted.data.Availabilities);
         var datesArray = scheduleWanted.data.Availabilities.map(
          ({ Staff:{DisplayName,Bio,Id},StartDateTime,EndDateTime}) => {
          const staffID = Id;
          const sessionTypeID = appointmentInfo;
	      const startDay = new Date(StartDateTime.replace("-07:00",""));
	      const startDateISO = StartDateTime.replace("-07:00",""); //might need + 1
	      const endDay  = new Date(EndDateTime.replace("-07:00",""));

	     const options = { timeZone: "America/New_York", hour: "numeric", minute: "2-digit", hour12: true };
    	     const startTime = startDay.toLocaleTimeString("en-US", options);
	     const endTime   = endDay.toLocaleTimeString("en-US", options);

             //time of day
            const hour = startDay.getHours(); // 0–23


            
              //startDay.setDate(startDate.getDate())
              const day = startDay.toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
               });

        //    //console.log(hour);
            let timeOfDay = "Morning";
            if (hour >= 12 && hour < 17) timeOfDay = "Afternoon";
            else if (hour >= 17 && hour < 21) timeOfDay = "Evening";
            else if (hour >= 21 || hour < 5) timeOfDay = "Night";

             return {
             staffID,
             startDateISO,
             sessionTypeID,
             DisplayName,
             Bio,
             day,
             startTime,
             endTime,
             timeOfDay,
            };
          }
        );

        var filteredDates = datesArray.filter(appt => allowed.includes(appt.timeOfDay));
        //console.log(datesArray);

        var newAppt = [...(filteredDates||[])]
        setAppointments(newAppt);
        //endDate.setDate(endDate.getDate()); 
        var startDayDate = endDate.toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
               });

        var reply = "";
        //console.log("Dates Array: " + datesArray + " Filter Array: " + filteredDates );
        if (datesArray.length === 0) reply = "No appointments were found on " + startDayDate + " is there another day you would be available?";
        else if (datesArray.length > 0 && filteredDates.length === 0) reply = "Appointments are available " + startDayDate + ", but not during your requested time of day, would you like a different time of day or another date?"
        else if (filteredDates.length > 0)
        {
           let prevDisplay = "";
            reply = "Here are the times available for " + startDayDate + "!";
            filteredDates.forEach((item, i) => {
                if(prevDisplay !== item.DisplayName){
                 reply = reply + "\n-" + item.DisplayName.trim() + "-\n";
                 prevDisplay = item.DisplayName;
                }
                if(i === filteredDates.length -1) {
                  reply = reply + item.startTime.trim() + "-" + item.endTime.trim() + "";
                } else {
                  reply = reply + item.startTime.trim() + "-" + item.endTime.trim() + ", ";
                }
            });
        }

         //set unique staff to add to memory
	var uniqueStaff = Object.values(
	  datesArray.reduce((acc, item) => {
	    const key = item.DisplayName; // could also combine DisplayName+Bio if needed
	    if (!acc[key]) {
	      acc[key] = {
	        DisplayName: item.DisplayName,
	        Bio: item.Bio
	      };
	    }
	    return acc;
	  }, {})
	);
        if (serviceData.length > 0) {
	        if (serviceData[serviceData.length - 1]["Staff Information"]) {
			uniqueStaff = Array.from(
			  new Map(
			    [...uniqueStaff, ...serviceData["Staff Information"]].map(item => [
			      item.DisplayName, // key
			      item               // value
			    ])
			  ).values()
			);
	        }
	        var tmpserviceData = serviceData;
	        tmpserviceData.pop();
	        tmpserviceData.push({"Staff Information":uniqueStaff});
        }
        setMessages([...newMessages, { sender: "bot", text: reply }]);


      } else {
        //    //console.log(process.env.REACT_APP_OPENAI_API_KEY)
         setMessages([...newMessages, { sender: "bot", text: "Oops we ran into an issue! Please input a date again." }]);
      }
        //TODO add Bio Display Name Id and bleh to appointment array for context.
  };



  const sendGPTMessage = async (prompt,message,newMessages) => {

    //console.log(prompt);
    prompt = prompt + "Todays Date: " + todaysDate;
    setLoading(true);
    try {
    const response = await axios.post("https://"+ip+"/api/chat", {
      messages: [
      { role: "system", content: prompt },
      { role: "user", content: message }
    ]
  });
//      //console.log(response)

      var reply = response.data.reply;

//TEST CASE:      var reply = "Some text here DATE-LOOKUP:1113:2025-08-29 more text here";
//TEST CASE 2      var reply = "Some text here APPOINTMENT-CONFIRMED:2025-08-29:1113 more text here";
      const regex = /DATE-LOOKUP:(?:{)?(\d+)(?:})?:(\d{4}-\d{2}-\d{2}):\[(.*?)\]/;
      const match = reply.match(regex);

     // const apptRegex = /APPOINTMENT-CONFIRMED:(?:{)?(\d+)(?:})?/;
      const apptRegex = /APPOINTMENT-CONFIRMED:(?:{)?(\d+)(?:})?:(?:{)?(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:})?:(?:{)?(\d+)(?:})?/;
      const apptMatch = reply.match(apptRegex);

      var callAppt = false;
      var timeOfDay = [];

       var apptID = -1;
       var currentDate = new Date(Date.now());

        if(match){

        //console.log(reply);

        const id = match[1];     // "42"
        const date = match[2];   // "2025-08-24"
        const timeOfDayRaw = match[3].trim();

        setAppointmentID(parseInt(id));                   // "123"
        setDate(new Date(date));

        //console.log("ID:", id);
        //console.log("Date:", date);

        // Remove the matched substring
        reply = reply.replace(regex, "").trim();
        //console.log("Cleaned message:", reply);

       // Turn into array
        timeOfDay = timeOfDayRaw
        ? timeOfDayRaw.split(",").map(t => t.replace(/["\s]/g, "")).filter(Boolean)
        : [];

        apptID = id;
        currentDate = new Date(date);

        callAppt = true;

      } 
      if  (apptMatch)
      {
        const staffID = apptMatch[1];
        const startDateISO = apptMatch[2];
        const sessionTypeID = apptMatch[3];
        //console.log(appointmentID);

        const bookingURL = buildAppointmentLink({
          sessionTypeId: sessionTypeID,
          staffId: staffID,
          startTime: startDateISO
        });

        //console.log(bookingURL);

        reply = "Awesome, we are so happy to have you! I am redirecting you to the mind body booking page to finish confirming your appointment! Simply highlight the time and therapist you want!" 

        if (popupsAllowed()) {
            redirectToBooking(bookingURL);
            reply = reply + "\n \nIf a tab doesn't open within the next 5 seconds here is the link: " + bookingURL;
        } else {
            reply = reply + "\n \nIt looks like your browser doesn't allow popups, either allow them or go to the following link: " + bookingURL;
        }


      }
      setMessages([...newMessages, { sender: "bot", text: reply }]);
      messageRef.current =([...newMessages, { sender: "bot", text: reply }]);

      /*if (callAppt) {
         await manageserviceData(apptID, currentDate,messageRef.current,timeOfDay);
      }*/
      
      if (!apptMatch && reply.includes("APPOINTMENT-CONFIRMED")) {
      	 setMessages([...newMessages, { sender: "bot", text: "Oops! We couldn't confirm your appointment, I can try again or help you schedule something else?" }]);
      }
      
       if (!match && reply.includes("DATE-LOOKUP")) {
      	 setMessages([...newMessages, { sender: "bot", text: "Oops! We couldn't lookup that date, I can try to lookup that date again or is there another date you want to try?" }]);
      }

    } catch (err) {
      //console.log(err)
      setMessages([...newMessages, { sender: "bot", text: "Oops! Something went wrong. Please ask me your question again in ~5 seconds" }]);
    } finally {
      setLoading(false);
    }
  };

  const sendMessage = async (message) => {
    const newMessages = [...messages, { sender: "user", text: message }];

    setMessages(newMessages);

    var prompt = await setDefaultPrompt(true);

    prompt = prompt + "\nHere is the context of previous messages between yourself and the user. You are 'bot' and the customer is 'user': " + JSON.stringify(messages);

    await sendGPTMessage(prompt,message, newMessages);
  };

  return (
    <div className="chat-container">
      <div className="chat-box">
        {messages.map((msg, i) => (
          <ChatBubble key={i} sender={msg.sender} text={msg.text} />
        ))}
        {loading && <ChatBubble sender="bot" text="Typing..." />}
      </div>
      <ChatInput onSend={sendMessage} />
    </div>
  );
};

export default App;
